import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../hooks/AuthContext';
import { setZoomWorkspace } from '../../../services/zoomAccountsService';
import ZoomAccountsManager from '../../../components/zoom/ZoomAccountsManager';

// Cuentas Zoom dentro del Calendario. Es la misma pantalla (y los mismos datos)
// que el Generador: comparten el componente y la colección `zoom_accounts`.
const ZoomAccountsPage = () => {
    const { user } = useAuth();
    const [ready, setReady] = useState(false);

    // Esperar a que el workspace esté resuelto antes de montar el manager: si se
    // suscribe antes, la consulta sale sin filtro y trae cuentas de otros workspaces.
    useEffect(() => {
        if (!user?.uid) return;
        let alive = true;
        setZoomWorkspace(user.uid).then(() => { if (alive) setReady(true); });
        return () => { alive = false; };
    }, [user?.uid]);

    if (!ready) {
        return (
            <div className="h-full flex items-center justify-center bg-gray-50">
                <div className="flex flex-col items-center gap-3">
                    <div className="w-8 h-8 rounded-lg bg-blue-500 animate-pulse" />
                    <p className="text-sm font-medium text-gray-400">Cargando cuentas Zoom...</p>
                </div>
            </div>
        );
    }

    // Sin `onClose`: dentro del Calendario la salida es el sidebar, no una ✕.
    return <ZoomAccountsManager />;
};

export default ZoomAccountsPage;
